/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.microcredentialing.pathways'},
});

const PathwaysItem = () => (
  <RouteLinkItem
    route="midas/microcredentialing/curricula-and-pathways/pathways"
    title={messages.title}
  />
);

export default PathwaysItem;
